import React, { useContext } from "react";

//import * as utils from './utils';

import { IonBackButton, IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from "@ionic/react";
import { useSendbirdStateContext } from "@wearesweet/sendbird-uikit-react";
import { useGroupChannelContext } from "@wearesweet/sendbird-uikit-react/GroupChannel/context";
import ChannelAvatar from "@wearesweet/sendbird-uikit-react/ui/ChannelAvatar";
import Icon, { IconColors, IconTypes } from "@wearesweet/sendbird-uikit-react/ui/Icon";
import IconButton from "@wearesweet/sendbird-uikit-react/ui/IconButton";
import Label, { LabelColors, LabelTypography } from "@wearesweet/sendbird-uikit-react/ui/Label";
import { ellipsisHorizontalCircleOutline } from "ionicons/icons";
import { AuthenticatedUserContext } from "../../../contexts/AuthenticatedUserContext";
import { useViewport } from "../../../utils/useViewport";
import { ChannelTitle } from "./ChannelTitle";

interface ChannelHeaderProps {
  className?: string;
}

const ChannelHeader: React.FC<ChannelHeaderProps> = ({ className = "" }) => {
  const globalStore = useSendbirdStateContext();
  const userId = globalStore?.config?.userId;
  const theme = globalStore?.config?.theme;
  const { member } = useContext(AuthenticatedUserContext);

  const channelStore = useGroupChannelContext();
  const { currentChannel, showSearchIcon, onSearchClick, onChatHeaderActionClick, onBackClick = () => {} } = channelStore;

  const subTitle = currentChannel?.members && currentChannel?.members?.length !== 2;
  const isMuted = currentChannel?.myMutedState === "muted";

  const { isDesktop, isMobile } = useViewport();

  return isMobile ? (
    <IonHeader translucent={true}>
      <IonToolbar>
        <IonButtons slot={"start"}>
          <IonBackButton defaultHref={isMobile ? "/mchat" : "/chat"} />
        </IonButtons>
        <IonButtons slot={"end"}>
          <IonButton routerLink={"/" + (isMobile ? "m" : "") + `chat/channels/${currentChannel?.url}/settings`} routerDirection={isDesktop ? "none" : "forward"}>
            <IonIcon icon={ellipsisHorizontalCircleOutline} slot={"icon-only"} />
          </IonButton>
        </IonButtons>

        <IonTitle>
          <ChannelAvatar
            theme={theme}
            //@ts-ignore
            channel={currentChannel}
            userId={userId}
            height={32}
            width={32}
          />
          <ChannelTitle channel={currentChannel} currentUserId={member?.id} />
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  ) : (
    <div className={`sendbird-chat-header ${className}`}>
      <div className="sendbird-chat-header__left">
        <Icon className="sendbird-chat-header__icon_back" onClick={onBackClick} fillColor={IconColors.PRIMARY} width="24px" height="24px" type={IconTypes.ARROW_LEFT} />
        <ChannelAvatar
          theme={theme}
          //@ts-ignore
          channel={currentChannel}
          userId={userId}
          height={32}
          width={32}
        />
        <Label className="sendbird-chat-header__left__title" type={LabelTypography.H_2} color={LabelColors.ONBACKGROUND_1}>
          <ChannelTitle channel={currentChannel} currentUserId={member?.id} />
        </Label>
        <Label className="sendbird-chat-header__left__subtitle" type={LabelTypography.BODY_1} color={LabelColors.ONBACKGROUND_2}>
          {subTitle}
        </Label>
      </div>
      <div className="sendbird-chat-header__right">
        {((typeof isMuted === "string" && isMuted === "true") || (typeof isMuted === "boolean" && isMuted)) && (
          <Icon className="sendbird-chat-header__right__mute" type={IconTypes.NOTIFICATIONS_OFF_FILLED} fillColor={IconColors.ON_BACKGROUND_2} width="24px" height="24px" />
        )}
        {showSearchIcon && !currentChannel?.isEphemeral && (
          <IconButton className="sendbird-chat-header__right__search" width="32px" height="32px" onClick={onSearchClick}>
            <Icon type={IconTypes.SEARCH} fillColor={IconColors.PRIMARY} width="24px" height="24px" />
          </IconButton>
        )}
        <IconButton className="sendbird-chat-header__right__info" width="32px" height="32px" onClick={onChatHeaderActionClick}>
          <Icon type={IconTypes.INFO} fillColor={IconColors.PRIMARY} width="24px" height="24px" />
        </IconButton>
      </div>
    </div>
  );
};

export default ChannelHeader;
